// This needs to be added to the new atc and the quantity update function end.
// updateProgressBar(document.querySelector('.totals__total-value').getAttribute('data-value'));


// Function to update the progress bar based on subtotal and dynamic slabs
function updateProgressBar(cartPrice) {
  let subtotal = parseFloat(cartPrice.replace(/AED |,/g, ''));
  console.log(subtotal);

  let progress = 0;
  let message = "";
  let activeSlab = 0;

  // Define the dynamic discount slabs with thresholds and discounts
  const slabs = [
    { threshold: 200, discount: 'freeshipping' },
    { threshold: 1000, discount: 5 },
    { threshold: 2500, discount: 10 },
    { threshold: 5000, discount: 15 }
  ];

  let nextSlab = null; // To track the next slab that can be unlocked

  // Loop through slabs to find where the subtotal fits
  for (let i = 0; i < slabs.length; i++) {
    let slab = slabs[i];

    if (subtotal <= slab.threshold) {
      progress = (subtotal/slab.threshold)*100;
      activeSlab = i;
      if (i === 0){
        message = `<p>Add products worth AED 200 to unlock free shipping</p>`;
      } else if (i === slabs.length - 1){
        message = `<p>Order value of AED ${slab.threshold+1} will unlock upto 20% off!</p>`;
      } else {
        message = `<p>Order value of AED ${slab.threshold+1} will unlock upto ${slabs[i+1].discount}% off!</p>`;
      }
      nextSlab = slab;
      break;
    } else {
      document.querySelector(`#progress-value .milestone-${i} .milestone-progress`).style.width = `100%`;
    }
  }

  if (!nextSlab && subtotal > slabs[slabs.length - 1].threshold) {
    // If subtotal is above all slabs, cap progress at 100%
    progress = 100;
    let highestDiscount = 20;
    message = `<p>Congrats! You have unlocked ${highestDiscount}% off!</p>`;
  }

  // Update the width of the progress bar and display the message
  console.log('progress is::',progress);
  document.querySelector(`#progress-value .milestone-${activeSlab} .milestone-progress`).style.width = `${progress}%`;
  document.getElementById("above-text-msg").innerHTML = message;
}
